import { createFileRoute } from "@tanstack/react-router";
import { PageHead, Panel, StatCard } from "@/project/components/dashboard-shell";
import { formatINR } from "@/project/data/sample";

export const Route = createFileRoute("/institution/reports")({ component: Reports });

function Reports() {
  return (
    <>
      <PageHead title="Reports" subtitle="Download monthly, cause-wise and donor reports." />
      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
        <StatCard label="This month" value={formatINR(184200)} tone="primary" />
        <StatCard label="Last month" value={formatINR(212500)} />
        <StatCard label="YTD" value={formatINR(1245000)} tone="good" />
        <StatCard label="Unique donors" value="418" />
      </div>
      <div className="mt-6 grid gap-4 md:grid-cols-2">
        {["Donation report (PDF)", "Donor list (Excel)", "Cause-wise report (CSV)", "Impact report (PDF)"].map((r) => (
          <Panel key={r} title={r}>
            <div className="flex items-center justify-between"><p className="text-sm text-foreground/65">Updated daily</p><button className="rounded-full bg-[var(--maroon)] px-4 py-2 text-xs font-semibold text-[var(--cream)]">Download</button></div>
          </Panel>
        ))}
      </div>
    </>
  );
}